module.exports = __webpack_public_path__ + "img/cbdtzz.58de4f9f.png";